import toNumber from "lodash/toNumber";
import get from "lodash/get";

export function formatValue(value, format) {
  if (!format) return value;
  return `${value}${format}`;
}

// The keyboard of a number input on a phone. iOS opens its big digit pad only when asked, with a separator key when the
// value may have decimals. That pad has no minus key: only a field set to accept negative values keeps the default
// keyboard. Without a minimum, a registration form asks for an age, a count, a number of nights: never negative
export function getNumericInputMode(min, allowsDecimals) {
  if (min !== undefined && min !== null && +min < 0) return undefined;
  return allowsDecimals ? "decimal" : "numeric";
}

// Reads a counter as typed. The decimal pad of a phone set to French, German, Spanish… only has a comma: read as the
// decimal point, where the counter's own reading would drop it
export function parseNumericInput(input) {
  return input.replace(",", ".").replace(/[^\w.-]+/g, "");
}

export function getNumericValue(field, data, name) {
  const { formatter } = field;
  const value = get(data, name) || 0;
  if (!formatter) return value;
  if (typeof value === "string") return toNumber(value.replace(formatter, ""));
  return toNumber(value);
}
